import React from "react";
import styles from "./PaymentOptions.module.css";

const WHATSAPP_NUMBER = "971567575811";

function PaymentOptions() {
  const handleConfirmViaWhatsApp = () => {
    const message =
      "Hi Tripontourism! I'd like to confirm my Desert Safari booking and pay later via WhatsApp / Cash.";
    const link = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      message
    )}`;
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <section className={styles.section}>
      <div className="container">
        <h2 className={styles.title}>Payment Options</h2>

        <div className="row g-3">
          <div className="col-12 col-md-6">
            <div className={styles.card}>
              <p className={styles.cardTitle}>
                Secure Online Payment
                <br />
                (Card / PayTabs)
              </p>
              <div className={styles.cardIcons}>
                <span className={styles.visa}>VISA</span>
                <span className={styles.mastercard} aria-hidden="true">
                  <span className={styles.circleRed}></span>
                  <span className={styles.circleYellow}></span>
                </span>
              </div>
              <p className={styles.cardSubtitle}>
                Pay securely online at checkout
              </p>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className={styles.card}>
              <p className={styles.cardTitle}>Pay Later via WhatsApp / Cash</p>
              <p className={styles.cardSubtitle}>
                Confirm via WhatsApp / Cash
              </p>
              <button
                type="button"
                className={styles.confirmBtn}
                onClick={handleConfirmViaWhatsApp}
              >
                Confirm Booking via WhatsApp
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PaymentOptions;
